export default __webpack_public_path__ + "static/media/Group 82482.c4c19eca.svg";